<div *ngIf="this.cards.length > 0" class="checkout-container">
  <div class="checkout-close">
    <button
      type="button"
      class="checkout-close-button"
      (click)="closeModal()"
      aria-label="Close">
      <span 
        class="checkout-close-icon" 
        aria-hidden="true">&times;
      </span>
    </button>
  </div>

  <div class="checkout-taxes">
    <div class="checkout-img-container">
      <img 
        class="checkout-img" 
        [src]="paymentContent.imageContent || defaultImage"
        (error)="onImageError($event)"
      >
    </div>
    <div class="checkout-payment">
      <div class="checkout-payment-header">
        <h3 class="checkout-title">{{ paymentContent.title }}</h3>
        <div class="checkout-acquisition">
          {{ paymentContent.isRent ? 'Alquiler por ' + paymentContent?.rentalDays + ' días' : 'Compra' }}
        </div>
      </div>
      <div class="checkout-payment-body">
        <div class="checkout-item">
          <span class="checkout-item-text">Subtotal:</span>
          <span class="checkout-item-text">${{previewTax?.totalAmount | dotSeparator:'EN' }}</span>
        </div>
        <div class="checkout-item">
          <span class="checkout-item-text">Impuesto de ventas:</span>
          <span class="checkout-item-text">${{previewTax?.totalTax | dotSeparator:'EN' }}</span>
        </div>
        <div class="checkout-item border">
          <span class="checkout-item-text">Total:</span>
          <span class="checkout-item-text">${{(previewTax?.totalAmount + previewTax?.totalTax) | dotSeparator:'EN' }}</span>
        </div>
        <div class="checkout-info-help">(Dólares estadounidenses)</div>
      </div>
    </div>
  </div>

  <div class="checkout-card-container">
    <h1 class="checkout-card-title">Método de pago</h1>
    <div *ngFor="let card of cardsList" class="checkout-card" (click)="selectCard(card)">
      <div class="checkout-card-name">
        <i 
          class="iconlace iconlace-check-status checkout-icon"
          [ngClass]="{'active-check': card.cardId === selectedCardId}">
        </i>
        <span class="checkout-card-text desk">{{ card.textCard }}</span>
        <span class="checkout-card-text mobile">{{ card.textCardPlane }}</span>
      </div>
      <span class="checkout-card-text">{{ card.date }}</span>
    </div>
  </div>

  <div class="checkout-button-container">
    <div class="pay">
      <button 
        class="btn checkout-button" 
        [disabled]="thereIsError" 
        [ngClass]="{disabled: thereIsError}" 
        (click)="pay()">Pagar
      </button>
    </div>
  
    <a 
      class="checkout-other-pay" 
      (click)="goToOtherPayment()"
      >Usar otro medio de pago
    </a>
  </div>

</div>
